import React, { useState } from 'react';
import work from "../img/work.jpg";
import movieWeb from '../img/A.M - Best movie collections and 5 more pages - Personal - Microsoft​ Edge 1_2_2024 10_02_02 PM.png';
import uiDesign from '../img/uidesign.png';
import gameWeb from '../img/client23.png';
import flowerWeb from '../img/Responsive Navigation Bar and 2 more pages - Personal - Microsoft​ Edge 10_19_2024 12_36_09 PM.png';
import webDesign from '../img/designWeb.jpg';
import chatApp from '../img/AM Chat App and 1 more page - Personal - Microsoft​ Edge 11_1_2024 8_48_40 AM.png';
import expenseTracker from '../img/expense-tracker.png';

const projects = [
  { img: chatApp, title: "AM Chat App", github: "https://github.com/yourusername/am-chat-app" },
  { img: movieWeb, title: "Movie Collection Site(PHP)", github: "https://github.com/yourusername/movie-collection" },
  { img: gameWeb, title: "Gaming Website(HTML&CSS)", github: "https://github.com/yourusername/gaming-website" },
  { img: flowerWeb, title: "Flower Shop Website(Html&CSS)", github: "https://github.com/yourusername/flower-shop" },
  { img: expenseTracker, title: "Expense Tracker(MERN Stack)", github: "https://github.com/yourusername/flower-shop" },


  
  
];

const designs = [
  { img: uiDesign, title: "UI Design Concept" },
  { img: work, title: "Mockup Showcase" },
  { img: webDesign, title: "Creative Design" },
  { img: flowerWeb, title: "Landing Page" },
];

const SectionTitle = ({ title, darkMode }) => (
  <h2 className={`text-2xl md:text-3xl font-bold mb-6 ${darkMode ? 'text-white' : 'text-gray-800'}`}>{title}</h2>
);

const Portfolio = (props) => {
  const [showAllProjects, setShowAllProjects] = useState(false);
  const [showAllDesigns, setShowAllDesigns] = useState(false);

  const displayProjects = showAllProjects ? projects : projects.slice(0, 5);
  const displayDesigns = showAllDesigns ? designs : designs.slice(0, 5);

  return (
    <div id={props.work} className={`container mx-auto py-24 px-4 ${props.darkMode ? 'bg-neutral-950' : 'bg-white'}`}>
      {/* Header */}
      <div className="text-center mb-16">
        <h1 className={`text-xl font-bold ${props.darkMode ? 'text-orange-500' : 'text-purple-800'}`}>Portfolio</h1>
        <h2 className={`text-3xl font-semibold ${props.darkMode ? 'text-white' : 'text-black'}`}>Works & Projects</h2>
        <p className="text-gray-400 mt-4 mx-auto w-full md:w-2/3">
        Showcasing my work in web design and development, featuring a range of projects from responsive websites to innovative applications.
        Each project reflects my commitment to quality, creativity, and user-centric design.
        </p>
       
      </div>

      {/* Designs Sectin */}
      <div className="mb-20">
        <SectionTitle title="Designs" darkMode={props.darkMode} />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {displayDesigns.map((design, index) => (
            <div key={index} className={`${props.darkMode ? 'dark:bg-neutral-900' : 'dark:bg-white'} bg-white rounded-md shadow-lg overflow-hidden hover:scale-105 transition `}>
              <img src={design.img} alt={design.title} className="w-full h-52 object-cover" />
              <div className="p-4">
                <h3 className={`text-center font-medium ${props.darkMode ? 'text-orange-500' : 'text-purple-800'}`}>{design.title}</h3>
              </div>
            </div>
          ))}
        </div>
        {designs.length > 5 && (
          <div className="text-center mt-6">
            <button
              onClick={() => setShowAllDesigns(!showAllDesigns)}
              className={`text-sm font-medium px-5 py-2 rounded-full border hover:bg-gray-100 dark:hover:bg-neutral-700 transition ${props.darkMode ? 'border-orange-500 text-white' : 'border-purple-800 text-black'}`}
            >
              {showAllDesigns ? 'Show Less' : 'Show More'}
            </button>
          </div>
        )}
      </div>

      {/* Projects Section */}
      <div>
        <SectionTitle title="Projects" darkMode={props.darkMode} />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {displayProjects.map((project, index) => (
            <div key={index} className={`${props.darkMode ? 'dark:bg-neutral-900' : 'dark:bg-white'} bg-white rounded-md shadow-lg overflow-hidden hover:scale-105 transition `}>
              <img src={project.img} alt={project.title} className="w-full h-52 object-cover" />
              <div className="p-4 text-center">
                <h3 className={`text-center font-medium ${props.darkMode ? 'text-orange-500' : 'text-purple-800'}`}>{project.title}</h3>
                <a
                  href={project.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 text-sm hover:underline mt-2 inline-block"
                >
                  View Project
                </a>
              </div>
            </div>
          ))}
        </div>
        {projects.length > 5 && (
          <div className="text-center mt-6">
            <button
              onClick={() => setShowAllProjects(!showAllProjects)}
              className={`text-sm font-medium px-5 py-2 rounded-full border hover:bg-gray-100 dark:hover:bg-neutral-700 transition ${props.darkMode ? 'border-orange-500 text-white' : 'border-purple-800 text-black'}`}
            >
              {showAllProjects ? 'Show Less' : 'Show More'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Portfolio;
